import React, { Component } from 'react';
import { Context } from "context";

// import styles from 'App.module.scss';
import Editor from "editor/Editor";
import Toasts from "components/toasts/Toasts";
import Blackout from "components/blackout/Blackout";
import Fullscreen from "react-full-screen";
import Warnings from "components/warnings/Warnings";
import Disclaimer from "components/disclaimer/Disclaimer";
import {detect} from "detect-browser";
import isTouchDevice from "is-touch-device/src";
import * as Sentry from "@sentry/browser";
import Progress from "components/progress/Progress";
import * as UIController from "controller/UIController";
import Cookies from "js-cookie";

import 'styles/themed-styles.scss';

export default class App extends Component {
    static contextType = Context;

    async componentDidMount() {
        if (Cookies.get('lightTheme')) this.context.setLightTheme(JSON.parse(Cookies.get('lightTheme')))
        this.displayBrowserWarning();
        this.displayTouchWarning();
        this.setSentryTags();
    }

    displayBrowserWarning = () => {
        const browser = detect();
        if(browser.name !== "chrome") {
            this.context.alert(this.context.text.copy.browserWarning, "neutral");
        }
    }

    displayTouchWarning = () => {
        if (isTouchDevice()) {
            this.context.alert(this.context.text.copy.touchWarning, "neutral")
        }
    }

    setSentryTags = () => {
        const url = new URL(window.location);
        const projectId = url.pathname.split("/")[1];

        Sentry.setExtra("project_id", projectId);
        if(this.context.user) {
            const {id, username, fullName} = this.context.user;
            Sentry.setUser({id, username, fullName});
        }
    }

    render() {
        const url = new URL(window.location);
        const projectId = url.pathname.split("/")[1];
        const disclaimerConfirmed = UIController.isDisclaimerConfirmed(projectId);
        if(!this.context.disclaimerConfirmed && disclaimerConfirmed) this.context.confirmDisclaimer();
        if (!this.context.disclaimerConfirmed && !disclaimerConfirmed) return <Disclaimer/>;

        if (this.context.loaded) return (
            <Fullscreen enabled={this.context.fullScreen} onChange={this.context.setFullScreen}>
                <div className={`${this.context.lightTheme ? "light" : "dark"} app`}>
                    <Toasts/>
                    <Blackout/>
                    <Warnings/>
                    <Editor/>
                </div>
            </Fullscreen>
    );

        return <Progress/>
    }

}
